import React from 'react'

export default class Check extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <polygon
          fill="#000"
          points="5.121 12.911 13.913 4.119 11.722 1.928 5.121 8.515 2.191 5.584 0 7.79"
          className="fill-current"
        />
      </g>
    );
  }
}
